export default __webpack_public_path__ + "static/media/Chomsky.b458685a.woff";